import { Routes, Route } from "react-router-dom";
import { CartProvider } from "@/lib/cart";
import { WishlistProvider } from "@/lib/wishlist";
import { AdminAuthProvider } from "@/lib/admin-auth";
import { Home } from "@/pages/Home";
import { ProductDetail } from "@/pages/ProductDetail";
import { Search } from "@/pages/Search";
import { Cart } from "@/pages/Cart";
import { Checkout } from "@/pages/Checkout";
import { OrderConfirmation } from "@/pages/OrderConfirmation";
import { Wishlist } from "@/pages/Wishlist";
import { Placeholder } from "@/pages/Placeholder";
import { AdminLogin } from "@/pages/admin/Login";
import { AdminDashboard } from "@/pages/admin/Dashboard";
import { AdminProducts } from "@/pages/admin/Products";
import { AdminProductForm } from "@/pages/admin/ProductForm";
import { AdminCategories } from "@/pages/admin/Categories";
import { AdminOrders } from "@/pages/admin/Orders";
import { AdminOrderDetail } from "@/pages/admin/OrderDetail";

export function App() {
  return (
    <CartProvider>
      <WishlistProvider>
        <AdminAuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/product/:slug" element={<ProductDetail />} />
            <Route path="/search" element={<Search />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/order/:id" element={<OrderConfirmation />} />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/account" element={<Placeholder title="Account" message="Buyer accounts are coming soon." />} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/products" element={<AdminProducts />} />
            <Route path="/admin/products/:id" element={<AdminProductForm />} />
            <Route path="/admin/categories" element={<AdminCategories />} />
            <Route path="/admin/orders" element={<AdminOrders />} />
            <Route path="/admin/orders/:id" element={<AdminOrderDetail />} />
          </Routes>
        </AdminAuthProvider>
      </WishlistProvider>
    </CartProvider>
  );
}
